import * as type from "../types";
import { get } from "../../config/Requests";
import { openSnackbarError, startLoader, openSnackbarInfoDispatch } from "./requestAction";
import { typeRoute, typeRefuel, typeZone, typeWarning, typeLayover } from "../../utils/staticData";
import { notArrayOrEmpty } from "../../utils/helpers";
import t from "../../languages/pl";
import guid from '../../utils/guid';
import { mapRoutesListRoute, mapCurrentRouteRoute } from './../../config/routes';
import instance from "../../config/axiosConfig";
import { tokenIdentifier } from '../../utils/staticData';
import { getToken } from '../../config/sessionData';
import moment from 'moment-timezone';

export const selectRoute = (id) => {
    return (dispatch, getState) => {
        let store = getState().mapRoutesReducer;
        let routeToSelect = findRouteById(store.routes, id);
        if (!routeToSelect)
            openSnackbarError(dispatch, t.unableToFindRoute);
        changeRouteStateInCollection(dispatch, store.routes, id, true);
        dispatch({
            type: type.SET_SELECTED_ROUTES,
            value: addRouteToSelected(store.selectedRoutes, routeToSelect)
        });
    };
};

export const deselectRoute = id => {
    return (dispatch, getState) => {
        let store = getState().mapRoutesReducer;
        let routeToDeselect = findRouteById(store.routes, id);
        changeRouteStateInCollection(dispatch, store.routes, id, false);
        let newRoutes = removeRouteFromSelected(store.selectedRoutes, routeToDeselect);
        if (!newRoutes)
            openSnackbarError(dispatch, t.unableToFindRoute);
        dispatch({
            type: type.SET_SELECTED_ROUTES,
            value: newRoutes
        });
    };
};

export const selectAllRoutes = () => {
    return (dispatch, getState) => {
        let store = getState().mapRoutesReducer;
        const driveFilter = getState().filterReducer.drive;
        const refuelFilter = getState().filterReducer.refuel;
        const outOfZoneFilter = getState().filterReducer.outOfZone;
        const warningsFilter = getState().filterReducer.warnings;
        changeAllRoutesSelectedStateWithFilters(dispatch, store.routes, true, driveFilter, refuelFilter, outOfZoneFilter, warningsFilter);
        dispatch({
            type: type.SET_SELECTED_ROUTES,
            value: store.routes
        });
    };
};

export const deselectAllRoutes = () => {
    return (dispatch, getState) => {
        let store = getState().mapRoutesReducer;
        changeAllRoutesSelectedState(dispatch, store.routes, false);
        dispatch({
            type: type.SET_SELECTED_ROUTES,
            value: []
        });
    };
};

export const clearRoutes = () => {
    return dispatch => {
        dispatch({
            type: type.SET_MAP_ROUTES,
            value: null
        });
        dispatch({
            type: type.SET_SELECTED_ROUTES,
            value: null
        });
        dispatch({
            type: type.SET_CURRENT_ROUTE,
            value: null
        });
        dispatch({
            type: type.CHANGE_SHOW_CURRENT_ROUTE,
            value: false
        });
    };
};

export const updateStartAddress = (routeId, address) => {
    return dispatch => {
        dispatch({
            type: type.UPDATE_START_ADDRESS,
            id: routeId,
            value: address
        });
    };
};

export const updateEndAddress = (routeId, address) => {
    return dispatch => {
        dispatch({
            type: type.UPDATE_END_ADDRESS,
            id: routeId,
            value: address
        });
    };
};
//server requests
export const getRoutes = (id, getLastRoutes = false) => {
    return (dispatch, getState) => {
        let routes = getState().mapRoutesReducer.routes;
        if (!Array.isArray(routes) || routes.length === 0)
            getRoutesAPI(dispatch, getState, id, getLastRoutes, fetchRoutes);
        else getRoutesAPI(dispatch, getState, id, getLastRoutes, fetchToExistingRoutes);
    };
};

const getRoutesAPI = (dispatch, getState, id, getLastRoutes = false, responseHandler) => {
    const selectedCar = getState().mapCarsReducer.selectedCar;
    let filters = getState().filterReducer;
    let params = {
        auto_id: id,
        data_od: !getLastRoutes ? filters.startDate : undefined,
        data_do: !getLastRoutes ? filters.endDate : undefined,
    };
    get(
        dispatch,
        mapRoutesListRoute,
        params,
        response => {
            responseHandler(dispatch, getState, response, getLastRoutes);
            getCurrentRoute(id, dispatch, selectedCar);
        }
    );
};

//fetch data from server
const fetchRoutes = function (dispatch, getState, response, getLastRoutes) {
    if (response.status !== 200)
        return;
    let newData = expandAndSortAllRoutes(response);
    dispatch({
        type: type.SET_MAP_ROUTES,
        value: newData
    });
    if(newData.length > 0){
        if (getLastRoutes) {
            dispatch({
                type: type.CHANGE_START_DATE,
                value: newData[newData.length - 1].data_od
            });
            // dispatch({
            //     type: type.CHANGE_END_DATE,
            //     value: newData[0].data_do
            // });
        }
    }
    if (!notArrayOrEmpty(newData))
        selectLastRoute(dispatch, getState);
};

const fetchToExistingRoutes = function (dispatch, getState, response, getLastRoutes) {
    if (response.status !== 200)
        return;
    let selectedRoutes = getState().mapRoutesReducer.selectedRoutes;
    let newData = expandAndSortAllRoutes(response);
    let newerData = selectRoutesInNewData(newData, selectedRoutes);
    dispatch({
        type: type.SET_MAP_ROUTES,
        value: newerData.routes
    });
    dispatch({
        type: type.SET_SELECTED_ROUTES,
        value: newerData.selected
    });
};

const selectRoutesInNewData = (newData, sortedSelected) => {
    let newSelected = [];
    let output = newData.map(data => {
        if(Object.keys(data).includes("trasa_id")){
            let selected = sortedSelected.find(element => element.trasa_id === data.trasa_id);
            if(!selected)
                return data;
        }
        else {
            let selected = sortedSelected.find(element => element.data === data.data);
            if(!selected)
                return data;
        }
        data.selected = true;
        newSelected.push(data);
        return data;
    });
    return { routes: output, selected: newSelected };
};

//private helpers
const selectLastRoute = (dispatch, getState) => {
    let store = getState().mapRoutesReducer;
    let routes = store.routes;
    let lastRoute = getLastRoute(routes);
    dispatch({
        type: type.SET_SELECTED_ROUTES,
        value: [lastRoute]
    });
    changeAllRoutesSelectedState(dispatch, routes, false);
    changeRouteStateInCollection(dispatch, routes, lastRoute.id, true);
};

//manipulate selected state of routes
const changeRouteStateInCollection = (dispatch, routes, id, newState) => {
    //input params routes => all routes, id = id of route to be selected, newState = route state decision (true or false)
    let newRoutes = routes.map(route => {
        if (route.id === id)
            route.selected = newState;
        return route;
    });
    dispatch({
        type: type.MARK_ROUTE_AS_SELECTED,
        value: newRoutes
    });
};



const changeAllRoutesSelectedState = (dispatch, routes, newState) => {
    if (!Array.isArray(routes))
        return;
    routes.forEach(route => route.selected = newState);
    dispatch({
        type: type.MARK_ROUTE_AS_SELECTED,
        value: routes
    });
};

const changeAllRoutesSelectedStateWithFilters = (dispatch, routes, newState, driveFilter, refuelFilter, outOfZoneFilter, warningsFilter) => {
    if (!Array.isArray(routes))
        return;
    routes.forEach(route => {
        route.selected = newState;
        if (!driveFilter) {
            if (route.type === typeRoute) {
                route.selected = !newState;
            }
        }
        if (!refuelFilter) {
            if (route.type === typeRefuel) {
                route.selected = !newState;
            }
        }
        if (!outOfZoneFilter) {
            if (route.type === typeZone) {
                route.selected = !newState;
            }
        }
        if (!warningsFilter) {
            if (route.type === typeWarning) {
                route.selected = !newState;
            }
        }
    });
    dispatch({
        type: type.MARK_ROUTE_AS_SELECTED,
        value: routes
    });
};

export const changeRoutesMarksVisibility = (value, markType) => {
    return (dispatch, getState) => {
        let routes = getState().mapRoutesReducer.routes;
        routes.forEach(route => {
                if (route.type === markType) {
                    route.selected = value;
                }
            }
        );
        dispatch({
            type: type.MARK_ROUTE_AS_SELECTED,
            value: routes
        });
    };
};

//private non-dispatch methods
const findRouteById = (routes, id) => {
    return routes.find(route => route.id === id);
};

const addRouteToSelected = (state, routeToAdd) => {
    if (!state) {
        return [routeToAdd];
    }
    else if (state && Array.isArray(state)) {
        return [...state, routeToAdd];
    }
    else return state;
};

const removeRouteFromSelected = (state, routeToDeselect) => {
    if (!state || !Array.isArray(state))
        return state;
    let newRoutes = state.filter(route => route.id !== routeToDeselect.id);
    return newRoutes;
};

const expandResponse = (elements, type) => {
    return elements.map(element => {
        element.id = guid();
        element.type = type;
        element.selected = false;
        return element;
    });
};

const checkDataType = data => {
    return (data.type === typeRoute || data.type === typeZone || data.type === typeLayover) ? "route" : "point";
};

const expandAndSortAllRoutes = (response) => {
    let routes = expandResponse(response.data[1][typeRoute].filter(element => element.postoj === false), typeRoute);
    let refuels = expandResponse(response.data[1][typeRefuel], typeRefuel);
    let zones = expandResponse(response.data[1][typeZone], typeZone);
    let warnings = expandResponse(response.data[1][typeWarning], typeWarning);
    let layovers = expandResponse(response.data[1][typeRoute].filter(element => element.postoj === true), typeLayover);
    return sortByDate([...routes, ...refuels, ...zones, ...warnings, ...layovers]);
};

const sortByDate = data => {
    return data.sort((a, b) => {
        let typeA = checkDataType(a);
        let typeB = checkDataType(b);
        if (typeA === "route" && typeB === typeA)
            return a.data_od - b.data_od;
        else if (typeA === "point" && typeB === typeA)
            return a.data - b.data;
        else if (typeA === "point" && typeB !== typeA)
            return a.data - b.data_od;
        else if (typeA === "route" && typeB !== typeA)
            return a.data_od - b.data;
    }).reverse();
};

const getLastRoute = (routes) => {
    if (routes[0].type === typeRoute)
        return routes[0];
    return getLastRoute(routes.slice(1, routes.length - 1));
};

export const getCurrentRoute = (id, dispatch, selectedCar) => {
    startLoader(dispatch);
    let config = {
        headers: { [tokenIdentifier]: getToken() },
        params: { auto_id: id }
    };
    instance
        .get(mapCurrentRouteRoute, config)
        .then(response => {
            dispatch({
                type: type.SET_CURRENT_ROUTE,
                value: response.data
            });
            dispatch({
                type: type.CHANGE_SHOW_CURRENT_ROUTE,
                value: response.data.w_trasie
            });
            if(response.data.data.length > 0){
                dispatch({
                    type: type.SET_SELECTED_CAR,
                    value: {...selectedCar, pozycja_gps: response.data.data[response.data.data.length - 1]}
                });
            }
        });
};

export const fetchCurrentRoute = (id) => {
  return (dispatch, getState) => {
    const currentRoute = getState().mapRoutesReducer.currentRoute;
    const lastCurrentRouteStatus = currentRoute.w_trasie;
    get(
      dispatch,
      mapCurrentRouteRoute,
      { auto_id: id },
      response => {
        if (response.data.w_trasie) {
          const selectedCar = getState().mapCarsReducer.selectedCar;
          dispatch({
            type: type.SET_CURRENT_ROUTE,
            value: response.data
          });
          if (response.data.data.length > 0){
            const pozycja_gps = response.data.data[response.data.data.length - 1];
          dispatch({
              type: type.SET_SELECTED_CAR,
              value: { ...selectedCar, pozycja_gps }});
        }} else {
          dispatch({
            type: type.SET_CURRENT_ROUTE,
            value: { data: [], w_trasie: false }
          });
          dispatch({
            type: type.CHANGE_SHOW_CURRENT_ROUTE,
            value: false
          });
          if (lastCurrentRouteStatus === true) {
            const selectedCar = getState().mapCarsReducer.selectedCar;
            const filters = getState().filterReducer;
            const currentDate = moment().unix();
            let params = {
              auto_id: id,
              data_od: filters.startDate,
              data_do: currentDate
            };
            get(
              dispatch,
              mapRoutesListRoute,
              params,
              response => {
                fetchRoutes(dispatch, getState, response, false);
                getCurrentRoute(id, dispatch, selectedCar);
                openSnackbarInfoDispatch(dispatch, t.car + ' ' + selectedCar.rejestracja + ' ' + t.finishedDrive);
              }
            );
          }
        }
      }
    );
  };
};

////do testów
// export const deleteCurrentRoute = (id) => {
//     return (dispatch, getState) => {
//         const currentRoute = getState().mapRoutesReducer.currentRoute;
//         const lastCurrentRouteStatus = currentRoute.w_trasie;
//         dispatch({
//             type: type.SET_CURRENT_ROUTE,
//             value: {data: [], w_trasie: false}
//         });
//         dispatch({
//             type: type.CHANGE_SHOW_CURRENT_ROUTE,
//             value: false
//         });
//         if(lastCurrentRouteStatus === true){
//             const selectedCar = getState().mapCarsReducer.selectedCar;
//             const filters = getState().filterReducer;
//             const currentDate = moment().unix();
//             let params = {
//                 auto_id: id,
//                 data_od: filters.startDate,
//                 data_do: currentDate
//             };
//             get(
//                 dispatch,
//                 mapRoutesListRoute,
//                 params,
//                 response => {
//                     fetchRoutes(dispatch, getState, response, false);
//                     getCurrentRoute(id, dispatch, selectedCar);
//                     openSnackbarInfoDispatch(dispatch, 'Samochód ' + selectedCar.rejestracja + ' zakończył jazdę');
//                 }
//             );
//         }
//     };
// };

////do testów
// export const changeTest = () => {
//     return (dispatch, getState) => {
//         const selectedCar = getState().mapCarsReducer.selectedCar;
//         let currentRoute = getState().mapRoutesReducer.currentRoute;
//         const last = currentRoute.data[currentRoute.data.length - 1];

//         const next = {
//             lat: last.lat - 0.002,
//             lon: last.lon - 0.002,
//             predkosc: 27,
//             predkosc_dopuszczalna: 50
//         };

//         const updatedcurrentRoute = {
//             ...currentRoute,
//             data: [
//                 ...currentRoute.data,
//                 next
//             ]
//         };
//         const data = currentRoute.data.concat();
//         currentRoute.data = data;
//         dispatch({
//             type: type.SET_CURRENT_ROUTE,
//             value: updatedcurrentRoute
//         });
//         dispatch({
//             type: type.SET_SELECTED_CAR,
//             value: {...selectedCar, pozycja_gps: updatedcurrentRoute.data[updatedcurrentRoute.data.length - 1]}
//         });
//     };
// };

export const changeShowingCurrentRoute = (value) => {
    return (dispatch) => {
        dispatch({
            type: type.CHANGE_SHOW_CURRENT_ROUTE,
            value: value
        });
    };
};
